module.exports = __webpack_public_path__ + "img/5.10fd2227.jpg";